import api from './api';

const todoService = {
  // Get all todos with filters
  getAllTodos: async (params = {}) => {
    const response = await api.get('/todos', { params });
    return {
      todos: response.data.todos || [],
      pagination: response.data.pagination || {}
    };
  },

  // Get todo by ID
  getTodoById: async (id) => {
    const response = await api.get(`/todos/${id}`);
    return response.data;
  },

  // Create new todo
  createTodo: async (todoData) => {
    const response = await api.post('/todos', todoData);
    return response.data;
  },

  // Update todo
  updateTodo: async (id, todoData) => {
    const response = await api.put(`/todos/${id}`, todoData);
    return response.data;
  },

  // Delete todo
  deleteTodo: async (id) => {
    const response = await api.delete(`/todos/${id}`);
    return response.data;
  },

  // Get todos grouped by status for board view
  getTodosByStatus: async (params = {}) => {
    const response = await api.get('/todos/board', { params });
    return response.data;
  },

  // Update todo order (for drag-and-drop)
  updateTodoOrder: async (id, order_index, status) => {
    const response = await api.patch(`/todos/${id}/order`, { order_index, status });
    return response.data;
  },

  // Bulk update todo orders (for drag-and-drop)
  bulkUpdateOrder: async (todos) => {
    const response = await api.patch('/todos/bulk/order', { todos });
    return response.data;
  },

  // Archive todo
  archiveTodo: async (id) => {
    const response = await api.patch(`/todos/${id}/archive`);
    return response.data;
  },

  // Unarchive todo
  unarchiveTodo: async (id) => {
    const response = await api.patch(`/todos/${id}/unarchive`);
    return response.data;
  },
};

export default todoService;

// --- - Todo Service